import React, { useState, useEffect, useContext, useMemo } from 'react'
import { debounce, throttle } from 'lodash';
import moment from "moment";
import { Tabs, Card, Button, Form, Row, Col, Select, DatePicker, TimePicker, Modal, message } from 'antd';
import Input from '../../../ui/Input';
import Collapse, { Panel} from '../../../ui/Collapse';
import { PlusOutlined } from '@ant-design/icons'
import { LocalPersistence } from '../../../../factories';
import { getOTACodes } from '../../../../services/common'
import { updateSchedule, deleteAmenityservice } from '../../../../services/amenityservice';
import PageContainer from '../../../CSIComponents/PageContainer';
import { rightContentWidthContext } from '../../../../layouts/RightContentWidthContext';
import Loading from '../../../Loading';
import ActionButtonsBar from '@ui/ActionButtonsBar';
const { TabPane } = Tabs;
const { Option } = Select;
const FormItem = Form.Item

let newTabIndex = 10;

export interface Operationtime {
  dayoftheweek: string;
  starttime: Date;
  endtime: Date;
}



export interface Session {
  scheduleid: number;
  startdate?: any;
  enddate?: any;
  operationtime: Operationtime[];
  charge: ChargeType[];
  closable: boolean;
  id: number;
  startDatePicker: any[];
}

let newTabIndexArr: any = [];
interface ChargeType{
  charge: number | null, 
  chargefrequency: string | null, 
  chargeunit:  string | null, 
  currency:  string | null, 
  id: number | null, 
  type:  string | null, 
}
const ScheduleAndChargeEdit = (props: any) => {
  const initialPanes = props.editData;
  const dateFormat = 'MM/DD/YYYY';
  const itemFormat = 'HH:mm';
  // let [newTabIndex, setNewTabIndex] = useState(0);
  const [form] = Form.useForm();
  const [activeKey, setActiveKey] = useState("0");
  const [disabledStatus, setDisabledStatus] = useState(true)
 
  useEffect(() => {
    initialPanes.forEach((item: any, index: number) => {
      item.closable = true;
      item.id = index;
      item.startDatePicker = item.startdate && item.enddate ? [moment(item.startdate, dateFormat), moment(item.enddate, dateFormat)] : [];
      item.operationtime.forEach((cell: any) => {
        cell.starttime = cell.starttime ? moment(cell.starttime, itemFormat) : ""
        cell.endtime = cell.endtime ? moment(cell.endtime, itemFormat) : ""
      })
      item.charge.forEach((cell: any, oIndex: any) => {
        cell.id = oIndex + 1
      })
    })
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  if (initialPanes.length === 1) {
    initialPanes[0].closable = false;
  }
  const rightContent: any = useContext(rightContentWidthContext);
  const [panes, setPanes] = useState(initialPanes);
  const [addId, setAddId] = useState(panes.length);
  const [editFlag, setEditFlag] = useState(false);
  const data = initialPanes || []
  const [detailData, setDetailData] = useState(data)

  const [refreshCount, setRefreshCount] = useState(0)
  const [currencyList, setCurrencyList] = useState<Array<any>>([]);
  const [chargeUnitList, setChargeUnitList] = useState<Array<any>>([]);
  const [ChargeFrequency, setChargeFrequency] = useState<Array<any>>([]);
  const [addLoading, setAddLoading] = useState(false)
  const [requiredFlag, setRequiredFlag] = useState(false)

  const onChange = (activeKey: any) => {
    
    setActiveKey(activeKey);
    props.getClickTabs(activeKey)
  };

  const onEdit = (targetKey: any, action: any) => {
    action === 'add' ? add() : remove(targetKey);
  };

  useEffect(() => {
    newTabIndex = panes.length > 0 ? panes.length - 1 : 0;
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  const add = async () => {
    newTabIndex = panes.length > 0 ? Number(panes.length - 1) : 0;
    const newKey = ++newTabIndex;
    newTabIndexArr.push(newKey)
    const newPanes = JSON.parse(JSON.stringify(panes));
    let id = addId

    let obj = {
      //"scheduleid": JSON.stringify(newKey),
      "startdate": "",
      "enddate": "",
      'id': id,
      'startDatePicker': [],
      "operationtime": [
        {
          "dayoftheweek": "Mon",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Tue",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Wed",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Thu",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Fri",
          "starttime": "",
          "endtime": ""
        },
        {
          "dayoftheweek": "Sat",
          "starttime": "",
          "endtime": ""
        }, {
          "dayoftheweek": "Sun",
          "starttime": "",
          "endtime": ""
        }
      ],
      "charge": [
        {
          "type": "  ",
          "charge": "",
          "currency": "",
          "chargeunit": "",
          "chargefrequency": "",
          'id': 1
        },
      ],
      closable: true
    }
    newPanes[0].closable = true;
    id++
    setAddId(id)
    newPanes.push(obj);
    setActiveKey(JSON.stringify(newKey));
    convertTimeToMoment(newPanes)
    setPanes(newPanes);
    setRequiredFlag(true)
  };
  const ModalHead = () => {
    return (
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '50px',
        lineHeight: '50px',
        textIndent: '10px',
        borderBottom: '1px solid #ccc',
        color: '#fff',
        background: '#06789D',
        fontSize: 18,
        width: '100%'
      }}>Confirm</div>
    )
  }
  const onChangeItem = () => {
    setRequiredFlag(true)
  }
  const remove = (targetKey: any) => {
    let daleteTitle = ""
    panes.forEach((pane: any, i: any) => {
      if (i == targetKey) {
        daleteTitle = pane.id;
      }
    });
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      transitionName: "",
      maskTransitionName: "",
      content: `Are you sure you want to delete Schedule ${daleteTitle + 1}?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk() {
        let newActiveKey = activeKey;
        let lastIndex = 0;
        panes.forEach((pane: any, i: any) => {
          if (i == targetKey) {
            lastIndex = i - 1;
          }
        });
        const newPanes = panes.filter((pane: any, i: any) => i !== Number(targetKey));
        if (newPanes.length && targetKey) {
          if (lastIndex >= 0) {
            newActiveKey = JSON.stringify(newPanes.length - 1);
            newTabIndex--
          } else {
            newActiveKey = "0";
          }
        }
        if (newPanes.length === 1) {
          newPanes[0].closable = false;

        }
        if (newPanes.length === 0) {
          form.resetFields();
          setRequiredFlag(false)
          validateFieldsError()
          return;
        }
        setActiveKey(newActiveKey);
        setPanes(newPanes);
      },
      onCancel() {

      },
    });



  };
  const deleteItem = (index: number, paneIndex: number) => {      
    const _detailData: Session[] = JSON.parse(JSON.stringify(panes))
    for (let i = 0; i < _detailData.length; i++) {
      if (i === paneIndex) {
        const chargeCount: number = _detailData[i].charge.length
        if(chargeCount === 1){
          const charge: ChargeType= {
            type:"",
            charge:Number(null),
            currency:"",
            chargeunit:"",
            chargefrequency:"",
            id:1,
          }
          _detailData[i].charge.splice(index, 1, charge);
        } else{ 
            _detailData[i].charge?.splice(index, 1)
             
        }
      }
    }
    convertTimeToMoment(_detailData)
    setPanes(_detailData)
  }


  const convertTimeToMoment = (data: any) => {
    data.forEach((item: any, index: number) => { 
      item.closable = true;
      if(item.startDatePicker && item.startDatePicker.length > 0){
       item.startDatePicker = [moment(moment.utc(item.startDatePicker[0]).format('MM/DD/YYYY')), moment(moment.utc(item.startDatePicker[1]).format('MM/DD/YYYY'))]
      } else {
        item.startDatePicker = item.startdate && item.enddate ? [moment(item.startdate, dateFormat), moment(item.enddate, dateFormat)] : [];
      }
      item.operationtime.forEach((cell: any, oIndex: any) => {
        if (cell.starttime) {
          let startH = new Date(cell.starttime).getHours()
          let startM = new Date(cell.starttime).getMinutes()
          cell.starttime = moment(('0' + startH).slice(-2) + ':' + ('0' + startM).slice(-2) + '', itemFormat)
  
        } else {
          cell.starttime = ""
        }
        if (cell.endtime) {
          let endH = new Date(cell.endtime).getHours()
          let endM = new Date(cell.endtime).getMinutes()
          cell.endtime = moment(('0' + endH).slice(-2) + ':' + ('0' + endM).slice(-2) + '', itemFormat)
        } else {
          cell.endtime = ""
        }
      })
    })
  }

  const addCertification = () => {
    let addCertificationData = JSON.parse(JSON.stringify(panes))
    for (let i = 0; i < addCertificationData.length; i++) {

      if (i === Number(activeKey)) {
        addCertificationData[i].charge.push({
          "type": "  ",
          "charge": "",
          "currency": "",
          "chargeunit": "",
          "chargefrequency": "",
          'id': panes[activeKey].charge.length + 1
        })
      }
      convertTimeToMoment(addCertificationData)
      setRefreshCount(refreshCount + 1)
      setPanes(addCertificationData)
    }
    

  }
  const onFormChange = (changedValues: any, allValues: any)=>{
    
    const sessionData : any[]= JSON.parse(JSON.stringify(panes))
    const charge : ChargeType[] = allValues[activeKey].charge;
    //const datePicker: any[] = allValues[activeKey].startDatePicker;
    const operations: any[] = allValues[activeKey].operationtime
    const value = changedValues[activeKey]
    const keyString = Object.keys(value)[0]
    
    let obj = value[keyString]

    convertTimeToMoment(sessionData)

    if(keyString === "charge") {
      charge.map((value:ChargeType)=>{
        if(value.charge)
           value.charge = Number(value.charge)
        if(value.type?.toLowerCase() === "percent")
          value.currency = ''
      })
      sessionData[activeKey].charge.splice(0, charge.length, ...charge)
    } 
    
    sessionData[activeKey].operationtime.splice(0, operations.length, ...operations)
    
    sessionData.forEach((value: Session, index: number) =>{
      if(Number(activeKey)=== index) {
        if((keyString.toLocaleLowerCase() === "startdatepicker")){
          if(!obj){
            sessionData[index].startDatePicker = null
          }
          else{
            sessionData[index].startDatePicker.splice(0, allValues[index].startDatePicker.length, ...allValues[index].startDatePicker)
          }
       }    
     } 
    })
   

    setPanes(sessionData)
  }

  const debouncedEventHandler = useMemo(
    () => debounce(onFormChange, 300)
  , [panes, activeKey]);
  

  const validateFieldsError = () => {
    form.validateFields().then(() => {
      setDisabledStatus(false)
    }).catch(() => {
      const detailErrNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;
      if (detailErrNum === 0) {
        setDisabledStatus(false)
      } else {
        setDisabledStatus(true)
      }
    }) 
  } 
  useEffect(() => { 
   form.setFieldsValue(panes)
   setRequiredFlag(true)
   validateFieldsError()  
   
  }, [panes])

  useEffect(() => {
    getCurrencyist()
    getChargeUnitList()
    getChargeFrequencyList()
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  const getCurrencyist = async () => {
    setAddLoading(true)
    await getOTACodes('CUR', '').then((res) => {
      if (res && res.otacodes && res.otacodes.length != 0) {
        res.otacodes.map((item: any) => item.key = item.codeName)
        setCurrencyList(res.otacodes)
        setAddLoading(false)
      } else {
        message.error({
          content: res?.error[0]?.message || 'operation failed'
        });
        setCurrencyList([])
      }
    })
  }

  const getChargeUnitList = async () => {
    setAddLoading(true)
    getOTACodes('CHG ', 'ChargeUnit').then((res) => {
      // setAddLoading(false)
      if (res && res.otacodes && res.otacodes.length != 0) {
        res.otacodes.map((item: any) => item.key = item.codeName)
        setChargeUnitList(res.otacodes)
        setAddLoading(false)
      } else {
        message.error({
          content: res?.error[0]?.message || 'operation failed'
        });
        setChargeUnitList([])
      }
    })

  }
  const getChargeFrequencyList = async () => {
    setAddLoading(true)
    getOTACodes('CHG ', 'ChargeFrequency').then((res) => {
      if (res && res.otacodes && res.otacodes.length != 0) {
        res.otacodes.map((item: any) => item.key = item.codeName)
        setChargeFrequency(res.otacodes)
        setAddLoading(false)
      } else {
        message.error({
          content: res?.error[0]?.message || 'operation failed'
        });
        setChargeFrequency([])
      }
    })

  }

  const addSave = async () => {
    
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    form.validateFields().then(async (value) => {
      console.log(value)
      for (let key in value) {
        value[key].startdate = (value[key].startDatePicker && value[key].startDatePicker.length > 0) && value[key].startDatePicker !== undefined ? (value[key].startDatePicker[0]).format('MM/DD/YYYY') : ''
        value[key].enddate = (value[key].startDatePicker && value[key].startDatePicker.length > 0) && value[key].startDatePicker !== undefined ? (value[key].startDatePicker[1]).format('MM/DD/YYYY') : ''
        value[key].startDatePicker = null;
        for (let i = 0; i < value[key].charge.length; i++) {
          if (value[key].charge[i] == undefined) {
            value[key].charge.splice(i, 1)
            i--
          }
        }
        for (let i = 0; i < value[key].operationtime.length; i++) {
          if (i == 0) {
            value[key].operationtime[i].dayoftheweek = 'Mon'
          } else if (i == 1) {
            value[key].operationtime[i].dayoftheweek = 'Tue'
          } else if (i == 2) {
            value[key].operationtime[i].dayoftheweek = 'Wed'
          } else if (i == 3) {
            value[key].operationtime[i].dayoftheweek = 'Thu'
          } else if (i == 4) {
            value[key].operationtime[i].dayoftheweek = 'Fri'
          } else if (i == 5) {
            value[key].operationtime[i].dayoftheweek = 'Sat'
          } else if (i == 6) {
            value[key].operationtime[i].dayoftheweek = 'Sun'
          }
          if (value[key].operationtime[i].endtime != "" && value[key].operationtime[i].endtime != undefined) {

            value[key].operationtime[i].endtime = value[key].operationtime[i].endtime.format('HH:mm')
          } else {
            //delete value[key].operationtime[i]
            //value[key].operationtime[i] = undefined
            value[key].operationtime[i].endtime = ""
          }
          if (value[key].operationtime[i].starttime != "" && value[key].operationtime[i].starttime != undefined) {

            value[key].operationtime[i].starttime = value[key].operationtime[i].starttime.format('HH:mm')
          } else {
            value[key].operationtime[i].starttime = ""
          }
        }
        for (let j = 0; j < value[key].charge.length; j++) {
          if (value[key].charge[j].type == undefined) {
            value[key].charge[j].type = ""
          }
          if (value[key].charge[j].chargefrequency == undefined) {
            value[key].charge[j].chargefrequency = ""
          }
          if (value[key].charge[j].chargefrequency == undefined) {
            value[key].charge[j].chargefrequency = ""
          }
          if (value[key].charge[j].charge) {
            value[key].charge[j].charge = Number(value[key].charge[j].charge)
          }
        }
      }
      for (let key in value) {
        if (value[key].startdate == '') {
          delete value[key].startdate;
        }
        if (value[key].enddate == "") {
          delete value[key].enddate;
        }
      }
      let editChargeData = [];
      for (let key in value) {
        editChargeData.push(value[key])
      }
      const param = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "amenityservice": [
            {
              "amsid": props.info.amsid,
              "amslangid": props.info.amslangid,
              "schedule": editChargeData
            }
          ]
        }
      }
      setAddLoading(true)
      const res = await updateSchedule(param);
      if (res.result.success) {
        form.resetFields();
        props.gerEditData(editChargeData)
        //setDetailData(editChargeData)
        props.setDisabledFlag(false)
        // changeInitData = JSON.parse(JSON.stringify(editChargeData))
        props.editPageCancelBtnClick();
        setEditFlag(!editFlag); props.cancelEditable();
        // props.handelCancelBtnClick();
        setAddLoading(false)
      } else {
        message.error({
          content: res?.error[0]?.message || 'operation failed'
        });
      }
    })
  }
  const DeleteClick = async () => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    var bodyData = {
      "supplier": session.supplier,
      "propertyId": session.propertyId,
      "property": {
        "amenityservice": [
          {
            "amsid": props.info.amsid,
            "amslangid": props.info.amslangid,

          }
        ]
      }
    }
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete this record?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk: async () => {
        const res = await deleteAmenityservice(bodyData);
        if (res.result.success) {
          setDetailData(detailData)
          props.editPageCancelBtnClick();
          props.cancelEditable();
          props.cancelAndSave()
        }
      },
      onCancel() {

      },
    });

  }


    const onCollapseChange = ()=>{
    }
  const handlCancelClick = () => {
    props.setDisabledFlag(false)
    props.setEditToDetail()
    //props.editPageCancelBtnClick();

  }
  const typeChange = (value: any) => {
    setRequiredFlag(true)

  }
  return (
    addLoading ? <Loading type="large" /> : <>
      {currencyList.length > 0 && chargeUnitList.length > 0 || ChargeFrequency.length > 0 ? <PageContainer>
        <Card style={{ marginBottom: '100px' }}>
          <Form
            form={form}
            layout="vertical"
            initialValues={panes}
            onValuesChange={debouncedEventHandler}
          >
            <Tabs
              type="editable-card" 
              onChange={onChange}
              activeKey={activeKey}
              onEdit={onEdit}
            >
              {panes.map((schedule: any, index: any) => {

                return (
                  <TabPane tab={'Schedule ' + (schedule.id + 1)} key={index} forceRender={true}>
                    <Card>

                      <Row gutter={24}>
                        <Col span={12}>
                          <Form.Item name={[schedule.id, 'startDatePicker']} label="Start Date ~ End Date">
                            <DatePicker.RangePicker format={dateFormat} onChange={onChangeItem} />
                          </Form.Item>
                        </Col>
                        <Col span={12}></Col>
                      </Row>
                      <Row>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                          <div style={{ display: 'flex', flexDirection: 'column-reverse', marginRight: 5, fontWeight: 'bold', }}>
                            <div style={{ height: 35 }}>Close</div>
                            <div style={{ height: 35 }}>Open</div>
                          </div>

                          {schedule.operationtime.map(
                            (operationtime: any, j: number) => {
                              return (
                                <div style={{ flex: 1, 'userSelect': 'none' }} key={index}>
                                  <div style={{ fontSize: 14, fontWeight: 500, }}>

                                    {operationtime.dayoftheweek}
                                  </div>
                                  <div style={{ display: 'none', fontSize: 14, fontWeight: 500, }}>
                                    <FormItem name={[schedule.id, 'operationtime', j, 'dayoftheweek']}
                                    >
                                      <Input value={operationtime.dayoftheweek} style={{ border: '0', color: '#333', backgroundColor: '#fff', }} disabled />
                                    </FormItem>
                                  </div>
                                  <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', padding: '20 0' }}>
                                    <div style={{ height: 40, lineHeight: '40px', width: '70%', margin: 'auto', cursor: 'pointer' }}>
                                      <FormItem name={[schedule.id, 'operationtime', j, 'starttime']}>
                                        <TimePicker onChange={onChangeItem} format={itemFormat} />
                                      </FormItem>

                                    </div>
                                  </div>
                                  <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', borderTop: '0', padding: '20 0' }}>
                                    <div style={{ height: 40, lineHeight: '40px', width: '70%', margin: 'auto', cursor: 'pointer' }}>
                                      <FormItem name={[schedule.id, 'operationtime', j, 'endtime']}>
                                        <TimePicker onChange={onChangeItem} format={itemFormat} />
                                      </FormItem>
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          )}
                        </div>
                      </Row>
                      <Collapse
                        defaultActiveKey={schedule.charge.map((_: {}, i: number) => i)}
                        key={refreshCount}
                        style={{ marginTop: '30px' }}
                        onChange={onCollapseChange}
                      >
                        <>
                          {schedule.charge.map((charge: ChargeType, v: number) =>
                          (
                            <React.Fragment key={v}>
                              {<Panel
                                style={{ width: '100%' }}
                                deleteButton={{
                                  action: () => deleteItem(v, index),
                                  title: `Are you sure you want to delete Charge ${v + 1}?`,
                                }}
                                header={`Charge ${v + 1}`}
                                key={v}
                              >
                                <Row gutter={24}>
                                  <Col span={6} key={`col1${v}`}>
                                    <FormItem name={[schedule.id, 'charge', v, 'type']} label="Charge Type">
                                      <Select onChange={typeChange} showSearch allowClear>
                                        <Option value="Amount">Amount</Option>
                                        <Option value="Percent">Percent</Option>
                                      </Select>
                                    </FormItem>
                                  </Col>
                                  <Col span={6} className="col-margin">
                                    <Form.Item shouldUpdate noStyle>
                                      {({ getFieldValue }) => {
                                        switch (getFieldValue([schedule.id, 'charge', v, 'type'])) {
                                          case 'Amount':
                                            return <><FormItem style={{ marginBottom: '2px' }} name={[schedule.id, 'charge', v, 'charge']} label={'Charge (Amount)'} rules={[
                                              { required: requiredFlag, message: 'This field is required' },
                                              { pattern: /^\d*(\.\d*)?$/, message: 'This field should be a number.' }
                                            ]}>
                                              <Input  type="number"/>

                                            </FormItem> <span className="blue-font">Please input the amount value for each charge. Input 0 if free of charge, or leave the field blank if not applicable.</span></>
                                          case 'Percent':
                                            return <FormItem name={[schedule.id, 'charge', v, 'charge']} label={'Charge (Percent)'} rules={[
                                              { required: requiredFlag, message: 'This field is required' },
                                              { pattern: /^\d*(\.\d*)?$/, message: "This field should be a number." }
                                            ]}>
                                              <Input type="number"/>
                                            </FormItem>
                                          default:
                                            return null
                                        }
                                      }}
                                    </Form.Item>
                                  </Col>
                                  <Col span={6} key={`col3${v}`}>
                                    <Form.Item shouldUpdate noStyle>
                                      {({ getFieldValue }) => {
                                        switch (getFieldValue([schedule.id, 'charge', v, 'type'])) {
                                          case 'Amount':
                                            return <FormItem name={[schedule.id, 'charge', v, 'currency']} label="Currency" rules={[{ required: requiredFlag, message: "This field is required" }]}>
                                              <Select allowClear defaultValue=""
                                              showSearch>
                                                {currencyList.length > 0 && currencyList.map((item: any, index: any) => {
                                                  return (
                                                    <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                                  )
                                                })}
                                              </Select>
                                            </FormItem>
                                          default:
                                            return null
                                        }
                                      }}
                                    </Form.Item>
                                  </Col>
                                  <Col></Col>
                                </Row>
                                <Row gutter={24}>
                                  <Col span={6} key={`col4${v}`}>
                                    <FormItem name={[schedule.id, 'charge', v, 'chargeunit']} label="Charge Unit" >
                                      <Select allowClear showSearch>
                                        {chargeUnitList.length > 0 && chargeUnitList.map((item: any, index: any) => {
                                          return (
                                            <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                          )
                                        })}</Select>
                                    </FormItem>
                                  </Col>
                                  <Col span={12} key={`col5${v}`}>
                                    <FormItem name={[schedule.id, 'charge', v, 'chargefrequency']} label="Charge Frequency" >
                                      <Select showSearch allowClear>
                                        {ChargeFrequency.length > 0 && ChargeFrequency.map((item: any, index: any) => {
                                          return (
                                            <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                          )
                                        })}</Select>
                                    </FormItem>
                                  </Col>
                                </Row>
                              </Panel>}</React.Fragment>

                          )
                          )}
                        </>
                      </Collapse>
                    </Card>
                    <span
                      style={{ marginBottom: '10px', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                      onClick={() => {
                        addCertification()
                      }}
                    >
                      <PlusOutlined style={{ marginRight: 4 }} />Add Charge
            </span>


                  </TabPane>


                )

              })}

            </Tabs></Form>
        </Card></PageContainer> : null}

        <ActionButtonsBar
            onDelete={DeleteClick}
            onCancel={handlCancelClick}
            onSave={addSave}
            disabledSave={disabledStatus}
            warningMsg={true}
        />

    </>
  )
}

export default ScheduleAndChargeEdit;


